export const LoadingService = {

  start: () => {
    const body = document.getElementsByTagName('BODY')[0];
    body.classList.add('loading');
  },

  stop: () => {
    const body = document.getElementsByTagName('BODY')[0];
    body.classList.remove('loading');
  }

}

export const AppLoading = () => {
  return (
    <div className="app-loading">
      <div className="app-loading-box">
        <img src="/images/loading.gif" alt=""/>
      </div>
    </div>
  );
}
